module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_troms_og_finnmark_pos.9e0257f9.png";